import tip from './tip.svg';
import light from './light.svg';
import photo from './photo.png';
import socialSecurity from './socialSecurity.png';
import pdf from './pdf.png';
import fault11 from './11/fault.png';
import right11 from './11/right.png';
import fault12 from './12/fault.png';
import right12 from './12/right.png';
import fault25 from './25/fault.png';
import right25 from './25/right.png';

export default {
  tip,
  light,
  photo,
  socialSecurity,
  pdf,
  fault11,
  right11,
  fault12,
  right12,
  fault25,
  right25,
};
